'use client';

import { makeAutoObservable } from 'mobx';
import { AiHistorySidebarStore } from '@/components/Ai/AiHistorySidebar/store';
import { AiSidebarStore } from '@/components/Ai/AiSidebar/store';
import { CreatePostModalStore } from '@/components/CreatePostModal/store';
import { NavbarStore } from '@/components/Navbar';
import { PostsArchiveSidebarStore } from '@/components/PostsArchiveSidebar/store';

export class UiStore {
  navbar: NavbarStore;
  createPostModal: CreatePostModalStore;
  postsArchiveSidebar: PostsArchiveSidebarStore;
  aiSidebar: AiSidebarStore;
  aiHistorySidebar: AiHistorySidebarStore;
  isMobile: boolean;

  constructor() {
    makeAutoObservable(this, undefined, {
      autoBind: true,
    });

    this.isMobile = window.innerWidth < 768;
    this.navbar = new NavbarStore(this);
    this.createPostModal = new CreatePostModalStore(this);
    this.postsArchiveSidebar = new PostsArchiveSidebarStore(this);
    this.aiSidebar = new AiSidebarStore(this);
    this.aiHistorySidebar = new AiHistorySidebarStore(this);
  }
}
